export default "__VITE_ASSET__NACSkKWl__"